import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type Stat = { label: string; value: string };

export function StatStrip({ stats }: { stats: Stat[] }) {
  const theme = useTheme();
  return (
    <View style={[styles.row, { borderTopColor: theme.colors.rule, borderBottomColor: theme.colors.rule }]}>
      {stats.map((s, i) => (
        <View key={s.label + i} style={[styles.item, { borderRightColor: theme.colors.rule }]}>
          <Text variant="eyebrow" tone="fgMute">{s.label}</Text>
          <Text
            style={{
              fontFamily: theme.fontFamily.displayItalic,
              fontStyle: 'italic',
              fontSize: 56,
              lineHeight: 60,
              color: theme.colors.fg,
              marginTop: 8,
            }}
          >
            {s.value}
          </Text>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderTopWidth: 1,
    borderBottomWidth: 1,
  },
  item: {
    flex: 1,
    minWidth: 220,
    paddingHorizontal: 24,
    paddingVertical: 32,
    borderRightWidth: 1,
  },
});
